import './styles/index.scss';
import '@quasar/extras/material-icons/material-icons.css';
import Notify from 'quasar/src/plugins/notify/Notify.js';;
import langKr from 'quasar/lang/ko-KR';
// To be used on app.use(Quasar, { ... })
export default {
  lang: langKr,
  config: {
    notify: {
      /* look at QuasarConfOptions from the API card */
    },
  },
  plugins: {
    Notify,
  },
};
